export default __webpack_public_path__ + "static/media/Win.0f89903d.svg";